// useLanguageSelectors.ts
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, SupportedLocaleCode } from '@constants/locales';

export const useLanguage = () => {
    const { i18n } = useTranslation();

    const changeLanguage = (language: SupportedLocaleCode) => {
        i18n.changeLanguage(language);
    };

    const supportedLanguages = SUPPORTED_LOCALES;
    const currentLanguage = supportedLanguages.find(
        ({ code }) => code === i18n.language,
    );

    return {
        changeLanguage,
        currentLanguage,
        supportedLanguages,
    };
};

export default useLanguage;
